<div class="side-panel-footer">
  @if (loading) {
    <p-skeleton height="69px" class="skeleton-footer" styleClass="mb-2" />
  } @else {
    <!-- Split button actions -->
    <p-splitButton
      [label]="mainButtonLabel"
      [model]="splitItems"
      outlined
      (onClick)="mainButtonFunction()"
      severity="secondary"
    />
    <!-- Like buttons -->
    <p-button
      class="flex-like"
      icon="pi pi-thumbs-up"
      label="{{ likeButtonData?.likesCount }}"
      [outlined]="!likeButtonData?.likedByMe"
      severity="secondary"
      (click)="likeButtonData?.onClick()"
    />
  }
</div>
